<template>
  <va-select
    v-model="selectedCategory"
    searchable
    :loading="isLoading"
    textBy="name"
    keyBy="id"
    ref="categorySelect"
    :noClear="false"
    :options="
      categories.filter(el => serchFunc(el))
    "
    @update-search="scrollSelectorAndUpdate"
    :placeholder="title"
  />
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'SelectCategory',
  props: {
    value: {
      type: [Array, Number],
      default: () => ([]),
    },
    title: {
      type: String,
      default() { return this.$t('categories.selectCategory') },
    },
    filterBy: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      search: '',
      selectedCategory: '',
      isLoading: true,
      categoryQueryParams: {
        page: 1,
        limit: 4,
        ...this.filterBy,
      },
    }
  },
  watch: {
    value: function () {
      this.selectedCategory =
        this.categories.find(el => el.id === this.value) ?? {}
    },
    selectedCategory: {
      deep: true,
      handler: async function () {
        await this.$emit('input', this.selectedCategory?.id)
        await this.$refs.categorySelect.closeDropdown()
      },
    },
  },
  computed: {
    ...mapState({
      categories: state => state.Categories.items,
      haveCategories: state => state.Categories.hasItems,
    }),
  },
  methods: {
    serchFunc(el) {
      let filter = el.name?.toLowerCase()?.includes(this.search?.toLowerCase())
      if (Object.keys(this.filterBy).length > 0) {
        for (const key in this.filterBy) {
          filter = el[key] === this.filterBy[key]
        }
      }
      return filter
    },
    scrollSelectorAndUpdate: debounce(function (e) {
      this.$nextTick(async () => {
        const contentSelector = this.$refs.categorySelect.$el.querySelector(
          '.va-dropdown__content',
        )

        if (typeof e === 'string') {
          this.search = e
          if (e) {
            console.log(this.$refs.categorySelect)
            await this.$refs.categorySelect.closeDropdown()
            // await this.$refs.categorySelect.clear()
            await this.$refs.categorySelect.openDropdown()
          }
        }
        if (
          this.haveCategories &&
          contentSelector?.scrollHeight - 50 <
          contentSelector?.scrollTop + contentSelector?.clientHeight
        ) {
          this.categoryQueryParams.page++
          this.isLoading = true
          await this.get(this.categoryQueryParams)
          this.isLoading = false
        }
      })
    }, 500),
    ...mapActions('Categories', ['get', 'getItem']),
    async setOptions() {
      this.isLoading = true
      await this.get(this.categoryQueryParams)
      this.isLoading = false
      if (Array.isArray(this.value)) {
        this.selectedCategory =
          this.categories.filter(el => this.value.includes(el.id)) ?? []
      } else {
        this.isLoading = true
        if (Object.keys(this.value).length > 0) {
          await this.getItem(this.value)
        }
        this.isLoading = false
        this.selectedCategory =
          this.categories.find(el => el.id === this.value) ?? {}
      }
    },
  },
  created() {
    this.setOptions()
    this.$nextTick(() => {
      this.$refs.categorySelect.$el.onwheel = this.scrollSelectorAndUpdate
    })
  },
}
</script>
